import React, {useState} from 'react';
import Card from "../components/card/card";
import Filter from "../components/filter";
import CoverLoading from "../components/cover-loading";
import {Link} from "react-router-dom";


const Abroad = () => {
    const [post,setPost] = useState([])
    const [loading,setLoading] = useState(false)
    return (
        <div className='main-container justify-content-start'>
            {loading ? <CoverLoading/> : ''}
            <Filter path='abroad' setPost={setPost} setLoading={setLoading}/>
            <div className="row justify-content-end">
                <div className="col-3">
                    <Link to={'/add-abroad'} className='btn btn-primary'>Create Lesser Armenia Tour</Link>
                </div>
            </div>
            <div className="list-posts">
                {post.map((e)=><Card path='abroad' post={post} setPost={setPost} setLoading={setLoading} key={e.id} data={e}/>)}
            </div>
        </div>
    );
};

export default Abroad